/**
 * author: Patrick Vyn Badiang
 *
 * description:
 * is the constitution page manager
 * Calls a new article component for each article section
 * gives it the path of the file  and gives a title.
 */

import { Box } from "@mui/material";
import Article from "./Article";
import PageHero from "../../../utils/PageHero";
import constitutionHero from "../../../pictures/Hero/ConstitutionHero.svg";


function ConstitutionPage() {

    return (
        <>
            <PageHero
                image={constitutionHero}
                viewBoxWidth={1030}
                viewBoxHeight={304}
                cropHeight={304}
                bandColor="#224541"
                accessibleTitle="Fasa's Constitution"
                subtitle="Last ratified June 16, 2025. Click any article below to read the full text."
                subtitleColor="#efe7d3"
                pt={{ xs: "134px", sm: "130px", md: "140px", lg: "150px" }}
                pb={{ xs: "40px", md: "56px" }}
            />

            <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
                <Box sx={{ maxWidth: "1200px", mx: "auto", display: "flex", flexDirection: "column", gap: "14px" }}>
                    <Article title="Article I: The Organization"
                        path='/textfiles/Constitution/ArticleI.txt' />
                    <Article title="Article II: Membership"
                        path='/textfiles/Constitution/ArticleII.txt' />
                    <Article title="Article III: Meeting Classification"
                        path='/textfiles/Constitution/ArticleIII.txt' />
                    <Article title="Article IV: Event Determination"
                        path='/textfiles/Constitution/ArticleIV.txt' />
                    <Article title="Article V: Risk Management Policy"
                        path='/textfiles/Constitution/ArticleV.txt' />
                    <Article title="Article VI: Conduct"
                        path='/textfiles/Constitution/ArticleVI.txt' />
                    <Article title="Article VII: Executive Board"
                        path='/textfiles/Constitution/ArticleVII.txt' />
                    <Article title="Article VIII: Officer Board"
                        path='/textfiles/Constitution/ArticleVIII.txt' />
                    <Article title="Article IX: Impeachment"
                        path='/textfiles/Constitution/ArticleIX.txt' />
                    <Article title="Article X. Scholarship"
                        path='/textfiles/Constitution/ArticleX.txt' />
                    <Article title="Article XI: Amending the Constitution"
                        path='/textfiles/Constitution/ArticleXI.txt' />
                    <Article title="Article XII: Executive Board Duties and Powers"
                        path='/textfiles/Constitution/ArticleXII.txt' />
                    <Article title="Article XIII: Officer Board Duties and Powers"
                        path='/textfiles/Constitution/ArticleXIII.txt' />
                    <Article title="Article XIV: Revisions to the Constitution"
                        path='/textfiles/Constitution/ArticleXIV.txt' />
                </Box>
            </Box>
        </>
    );
}

export default ConstitutionPage;
